import { createContext, useContext } from 'react';
import type { CognitionCtxValue } from './types';

// Shares the run payload + lifecycle flags down the section tree without prop
// drilling (mirrors deep-signal/context.ts). The container is the only writer.
export const CognitionCtx = createContext<CognitionCtxValue>({
  runResult: null,
  phase: 'setup',
  isPreview: true,
  isStreaming: false,
  isComplete: false,
  modelLabel: (id: string) => id,
});

export function useCognition(): CognitionCtxValue {
  return useContext(CognitionCtx);
}
